import { newBox } from "./boxes";
import { blankTest } from "./dice_test";
import type { MenuGroup } from "./floating";
import { diceForm, kindPicker } from "./panels";
import { insertLink, insertMap, insertPicture, insertStage, insertTag, type PickerContext } from "./pickers";
import { insertBlock, newTable } from "./pieces";

export type InsertContext = PickerContext;

// The groups of the Inserir menu and of the `/` menu, in the order shown.
export function insertGroups(c: InsertContext): MenuGroup[] {
	const { t, editor } = c;
	const tagItem = (label: string, name: string) => ({ label: t(label), run: () => insertTag(c, name) });
	return [
		{
			label: t("group_sheets"),
			items: [
				tagItem("sheet_monster", "MONSTERBOX"),
				tagItem("sheet_spell", "SPELLBOX"),
				tagItem("sheet_character", "CHARACTERBOX"),
				tagItem("sheet_retainer", "RETAINERBOX"),
			],
		},
		{
			label: t("group_links"),
			items: [
				tagItem("link_monster", "MONSTRO"),
				tagItem("link_spell", "MAGIA"),
				tagItem("link_item", "EQUIPAMENTO"),
				{ label: t("link_chapter"), run: () => insertLink(c, "capitulo") },
				{ label: t("link_book"), run: () => insertLink(c, "livro") },
			],
		},
		{
			label: t("group_pieces"),
			items: [
				{
					label: t("insert_box"),
					hint: t("insert_box_hint"),
					run: () =>
						c.openPanel(t("panel_box"), (close) =>
							kindPicker(c, (cls) => {
								insertBlock(editor, newBox(cls));
								close();
							}),
						),
				},
				{
					label: t("insert_test"),
					hint: t("insert_test_hint"),
					run: () =>
						c.openPanel(t("panel_test"), (close) =>
							diceForm(c, blankTest, t("insert_test_submit"), (node) => {
								insertBlock(editor, node);
								close();
							}),
						),
				},
				{ label: t("insert_stage"), hint: t("insert_stage_hint"), run: () => insertStage(c) },
				{ label: t("insert_map"), hint: t("insert_map_hint"), run: () => insertMap(c) },
				{ label: t("insert_picture"), hint: t("insert_picture_hint"), run: () => insertPicture(c) },
				{
					label: t("insert_table"),
					hint: t("insert_table_hint"),
					run: () => {
						const from = insertBlock(editor, newTable(t));
						editor.commands.setTextSelection(from + 3);
					},
				},
				{ label: t("insert_rule"), run: () => insertBlock(editor, { type: "rawHtmlBlock", attrs: { raw: "---", ial: null } }) },
				{
					label: t("insert_html"),
					hint: t("insert_html_hint"),
					run: () => insertBlock(editor, { type: "rawHtmlBlock", attrs: { raw: "<div></div>", ial: null } }),
				},
			],
		},
	];
}
